import React, { useState, useEffect } from 'react';
import { Icon } from 'antd';
import { useSelector } from 'react-redux';
import { closeQuestionRejectedSelector } from '../../store/selectors';
import { setCloseQuestionRejected } from '../../store/actions';
import cn from 'classnames';
import IconCheckbox from '../../../../components/icon-checkbox';
import useFilterChange from '../../hooks/useFilterChange';
import styles from './CloseQuestionRejectedCheckbox.module.scss';

const CloseQuestionRejectedCheckbox = () => {
  const closeQuestionRejected = useSelector(closeQuestionRejectedSelector);

  const [value, setValue] = useState(closeQuestionRejected);

  const change = useFilterChange({ action: setCloseQuestionRejected });

  const handleChange = (val) => {
    setValue(val);
    change(val);
  };

  useEffect(() => {
    setValue(closeQuestionRejected);
  }, [closeQuestionRejected]);

  return (
    <IconCheckbox
      icon={
        <Icon
          type="minus-circle"
          className={cn(styles.icon, {
            [styles.active]: closeQuestionRejected,
          })}
        />
      }
      value={value}
      onChange={handleChange}
      className={styles.root}
    >
      Запрос на закрытие вопроса отклонен
    </IconCheckbox>
  );
};

export default CloseQuestionRejectedCheckbox;
